import { Controller } from "@hotwired/stimulus";

// Shows and hides target elements
export default class extends Controller {
  static targets = ["content"];
  static classes = ["hidden"];

  toggle() {
    this.contentTargets.forEach((el) => el.classList.toggle(this._hiddenClass));
  }

  show() {
    this.contentTargets.forEach((el) => el.classList.remove(this._hiddenClass));
  }

  hide() {
    this.contentTargets.forEach((el) => el.classList.add(this._hiddenClass));
  }

  // Private

  get _hiddenClass() {
    return this.hasHiddenClass ? this.hiddenClass : "hidden";
  }
}
